module.exports = __webpack_public_path__ + "img/details_hr.2e7335dc.png";